function formatSearchParams(params?: Array<Record<'key' | 'value', string>>): string {
  // URLSearchParams removes the '?' from window.location.search
  const searchParams = new URLSearchParams(window.location.search);

  if (params) {
    params.forEach(({ key, value }) => {
      searchParams.append(key, value);
    });
  }

  return searchParams.toString().length > 0 ? `?${searchParams.toString()}` : '';
}

export default formatSearchParams;
